<div [formGroup]="internalForm" class="grid">
  <div class="col-4">
    <label class="label">Postleitzahl</label>
    <input nbInput
           fullWidth
           formControlName="zipCode"
           placeholder="PLZ"
           [status]="hasError('zipCode') ? 'danger' : 'basic'">
    @if (hasError('zipCode')) {
      <p class="error">PLZ erforderlich</p>
    }
  </div>

  <div class="col-4">
    <label class="label">Stadt</label>
    <input nbInput
           fullWidth
           formControlName="city"
           placeholder="Stadt"
           [status]="hasError('city') ? 'danger' : 'basic'">
    @if (hasError('city')) {
      <p class="error">Stadt erforderlich</p>
    }
  </div>

  <div class="col-4">
    <label class="label">Bundesland</label>
    <input nbInput
           fullWidth
           formControlName="state"
           placeholder="Bundesland"
           [status]="hasError('state') ? 'danger' : 'basic'">
    @if (hasError('state')) {
      <p class="error">Bundesland erforderlich</p>
    }
  </div>
</div>
